import React, { useState } from "react";
import { Modal, Button, DatePicker, notification } from "antd";
import { useMutation } from "@tanstack/react-query";
import { copyDailyReport } from "../../services/dailyReportsAPI";
import queryClient from "../../queryClient";
import dayjs from "dayjs";
import { DATE_PICKER_FORMAT } from "../../constants/dateConstants";

const CopyDailyReportModal = ({ visible, onClose, copyToDate, projectId }) => {
  const [copyFromDate, setCopyFromDate] = useState(dayjs(new Date()));
  const handleDateChange = (date, dateString) => {
    setCopyFromDate(date);
  };

  const { mutate: copyDailyReportMutation, isPending: isPendingCopy } =
    useMutation({
      mutationFn: copyDailyReport,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["daily-report"] });
        onClose();
        notification.success({ message: "Daily report copied" });
      },
      onError: (error) => {
        notification.error({
          message: "Failed to copy daily report",
          description: error.message,
        });
      },
    });

  const handleCopyDailyReport = () => {
    copyDailyReportMutation({
      projectId: projectId,
      copyFromDate: copyFromDate,
      copyToDate: copyToDate,
    });
  };

  return (
    <Modal
      title="Copy Daily Report From"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button
          loading={isPendingCopy}
          key="ok"
          type="primary"
          onClick={handleCopyDailyReport}
        >
          Copy
        </Button>,
      ]}
      centered
    >
      <div className="flex flex-col">
        <DatePicker
          className="max-w-44"
          format={DATE_PICKER_FORMAT}
          onChange={handleDateChange}
          value={copyFromDate}
        />
      </div>
    </Modal>
  );
};

export default CopyDailyReportModal;
